import fi from './fi.json';
import sv from './sv.json';
import en from './en.json';

const locales = {
  en: {label: 'English', data: en},
  fi: {label: 'Suomi', data: fi},
  sv: {label: 'Svenska', data: sv}
};

export const availableLanguages = Object.keys(locales).map((code) => ({
  code,
  label: locales[code].label
}));

export const getLang = (lang) => {
  const resolved = (lang || navigator.language).split('-')[0].toLowerCase();
  return locales[resolved] ? resolved : 'en';
};

export const getLocalizedStrings = (lang) => {
  return locales[getLang(lang)].data;
};
